import { z } from 'zod'

/**
 * Loose validation: unknown keys preserved; ensures JSON object shape for chat POST bodies.
 * Text may live on root or under OpenAI-style `choices[0].message`.
 */
export const chatCompletionResponseSchema = z
  .object({
    message: z.string().optional(),
    text: z.string().optional(),
    reply: z.string().optional(),
    blocks: z.array(z.unknown()).optional(),
    choices: z
      .array(
        z
          .object({
            message: z
              .object({
                content: z.string().optional(),
                blocks: z.array(z.unknown()).optional(),
              })
              .passthrough()
              .optional(),
            text: z.string().optional(),
          })
          .passthrough(),
      )
      .optional(),
    meta: z.record(z.string(), z.unknown()).optional(),
  })
  .passthrough()
